module.exports = __webpack_public_path__ + "fonts/VetoSans-BoldItalic_1.029c3b81.ttf";